module.exports = __webpack_public_path__ + "img/Capcut-icon.87097ab5.png";